// Dark map theme for Google Maps (Midnight / Charcoal Navy)
export const DARK_MAP_STYLES = [
  { elementType: "geometry", stylers: [{ color: "#141722" }] },
  { elementType: "labels.text.fill", stylers: [{ color: "#8ea0b5" }] },
  { elementType: "labels.text.stroke", stylers: [{ color: "#141722" }] },
  { featureType: "administrative", elementType: "geometry", stylers: [{ color: "#2b3448" }] },
  { featureType: "administrative.country", elementType: "geometry.stroke", stylers: [{ color: "#3d4b68" }] },
  { featureType: "administrative.province", elementType: "geometry.stroke", stylers: [{ color: "#3d4b68" }] },
  { featureType: "landscape", elementType: "geometry", stylers: [{ color: "#1c2232" }] },
  { featureType: "poi", elementType: "geometry", stylers: [{ color: "#1e2638" }] },
  { featureType: "poi", elementType: "labels.text.fill", stylers: [{ color: "#6b7d96" }] },
  { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#17232a" }] },
  { featureType: "road", elementType: "geometry", stylers: [{ color: "#252e42" }] },
  { featureType: "road", elementType: "labels.text.fill", stylers: [{ color: "#9ca9ba" }] },
  { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#2c3852" }] },
  { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ color: "#1c2538" }] },
  { featureType: "transit", elementType: "geometry", stylers: [{ color: "#222a3d" }] },
  { featureType: "water", elementType: "geometry", stylers: [{ color: "#0b0f19" }] },
  { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#4c5f78" }] },
];

// Light map theme — Standard / Light google map style
export const LIGHT_MAP_STYLES = [];

/**
 * Returns Google Maps styles array based on the current theme mode.
 * @param {boolean} isDark - true for dark mode, false for light mode
 * @returns {Array} Google Maps styles array
 */
export const getMapStyles = (isDark) => {
  return isDark ? DARK_MAP_STYLES : LIGHT_MAP_STYLES;
};

export default getMapStyles;
